import { render, staticRenderFns } from "./AssemblyGasWaterComponent.vue?vue&type=template&id=6c2510e7"
import script from "./AssemblyGasWaterComponent.vue?vue&type=script&lang=js"
export * from "./AssemblyGasWaterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
